import { post } from "@/utils/request";

export default {
    addAttention: query => post("/rrbi/contentAttention/addAttention", query),
    existAttention: query => post("/rrbi/contentAttention/existAttention", query),
    getCountByObjId: query => post("/rrbi/contentAttention/getCountByObjId", query),
};
